import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { RUN_LLM_USAGE_KEY } from '@/utils/queryKeys.ts';
import { get_run_llm_usage_url } from '@/utils/urls.ts';
import { LlmUsageSummary } from '@/types/llmUsage.ts';

const useRetrieveRunLlmUsage = (
  runId?: string,
  enabled = true,
): UseQueryResult<LlmUsageSummary, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: RUN_LLM_USAGE_KEY(automationId, runId),
    queryFn: async () => {
      const response = await apiClient.get<LlmUsageSummary>(get_run_llm_usage_url(runId));
      return response.data;
    },
    enabled: !!runId && enabled,
  });
};

export default useRetrieveRunLlmUsage;
